<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="toc"><h1>Table of Contents</h1>
<ol>
<li><a href="#/cover" id="np-0">Cover</a></li>
<li><a href="#/97839897349511" id="np-1">The Valley of the Shadow</a></li>
<li><a href="#/97839897349512" id="np-2">The Seven Missionaries</a></li>
</ol></nav>
<nav epub:type="landmarks" hidden="" id="landmarks">
<h1>Landmarks</h1>
<ol>
<li>
<a epub:type="cover" href="#/cover">Cover</a>
</li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?958f0d5e